module.exports = __webpack_public_path__ + "img/blog1.85ca460.png";